import {
    Component,
    Object3D,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ActiveCamera} from './active-camera.js';
import {vec3} from 'gl-matrix';

export class Inspect extends Component {
    static TypeName = 'inspect-base';
    /* The location where inspected object will transform to,
     * exists in Player's child */
    @property.object()
    locInspectedObj?: Object3D;

    @property.object({required: true})
    player!: Object3D;

    protected location = vec3.create();
    protected forward = vec3.create();
    protected headLocation = vec3.create();

    setTransformInfrontOf(
        a: Object3D,
        b: Object3D,
        distance = 1,
        height = 0,
        rotOffset = [0, 0, 0]
    ) {
        /* Set Transform of 'b' Object infront of 'a' Object */
        this.location = [0, 0, 0];
        this.forward = [0, 0, 0];
        this.headLocation = [0, 0, 0];
        a.getPositionWorld(this.location); /* Get 'a' location to output result in 'this.location' */
        const headObject = this.player.getComponent(ActiveCamera)?.getActiveCamera();
        headObject!.getForwardWorld(this.forward); /* Using 'headObject' to appear in Player's looking direction */
        headObject!.getPositionWorld(this.headLocation);

        /* Location */
        this.location[0] += this.forward[0] * distance; /* Combine Location with Forward */
        this.location[1] = this.headLocation[1] + height; /* Set Location Height to Head */
        this.location[2] += this.forward[2] * distance; /* Combine Location with Forward */
        b.setPositionWorld(this.location); /* Set 'b' to 'a' location */

        const locInspectedObj = this.locInspectedObj;
        if (!locInspectedObj) {
            console.error(
                `inspect-note(${this.object.name}): locInspectedObj is not defined`
            );
            return;
        }
        /* Rotation */
        //a.getTranslationWorld(this.location); /* Get new location */
        //b.lookAt(this.location, [0, 1, 0]); /* Rotate 'b' towards 'a' */

        b.setRotationWorld(locInspectedObj.getRotationWorld());
        b.rotateAxisAngleDegObject([1, 0, 0], rotOffset[0]); //Offset X
        b.rotateAxisAngleDegObject([0, 1, 0], rotOffset[1]); //Offset Y
        b.rotateAxisAngleDegObject([0, 0, 1], rotOffset[2]); //Offset Z

        //Bug: When looking too down/up and transform object infront of you, the object doesn't become in the middle
    }
}
